import { EClientStatus } from "../enums/client/EClient";
import { EInvoiceStatus } from "../enums/invoices/EInvoice";

export const getInvoiceStatusColor = (status: EInvoiceStatus) => {
  if (status === EInvoiceStatus.OVERDUE) {
    return "error";
  }
  if (status === EInvoiceStatus.PAID) {
    return "success";
  }
  if (status === EInvoiceStatus.PENDING) {
    return "warning";
  }
  return "primary";
};

export const getClientStatusColor = (status: EClientStatus) => {
  if ([EClientStatus.REJECTED, EClientStatus.EXPIRED]?.includes(status)) {
    return "error";
  }
  if (status === EClientStatus.ACTIVE) {
    return "success";
  }
  if (status === EClientStatus.PENDING) {
    return "warning";
  }
  return "primary";
};

export const getEmailListStatusColor = (status: string) => {
  if (status === "PENDING") {
    return "warning";
  }
  if (status === "FAILED") {
    return "error";
  }
  return "success";
};
